/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 scene.gltf --transform
Author: Paxar095 (https://sketchfab.com/paxar095)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/rain-3-6021e79c421344af9667469aa472389b
Title: Rain 3
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Rain(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('./models/rain_3/scene-transformed.glb')
  const { actions } = useAnimations(animations, group)

useEffect(()=> {
  actions['Take 001'].play();
})

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]}>
          <group name="a7f6f84b188143daa3c5cfeaf0cd1fe3fbx" rotation={[Math.PI / 2, 0, 0]}>
            <group name="Object_2">
              <group name="RootNode">
                <group name="rain" rotation={[-Math.PI / 2, 0, 0]} scale={2.54}>
                  <group name="cloud_101" position={[34.2, -11.32, 236.75]} rotation={[0, 0, Math.PI]}>
                    <mesh name="cloud_101_Material_#0_0" geometry={nodes['cloud_101_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                  <group name="cloud_102" position={[-49.27, -46.35, 233.68]} rotation={[0.62, -0.14, 0.1]}>
                    <mesh name="cloud_102_Material_#0_0" geometry={nodes['cloud_102_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                  <group name="cloud_104" position={[-39.61, 31.12, 233.39]}>
                    <mesh name="cloud_104_Material_#0_0" geometry={nodes['cloud_104_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                  <group name="cloud_103" position={[83.45, -32.56, 223.47]}>
                    <mesh name="cloud_103_Material_#0_0" geometry={nodes['cloud_103_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                  <group name="cloud_105" position={[-66.7, 86.43, 217.68]} rotation={[0, 0, -2.97]}>
                    <mesh name="cloud_105_Material_#0_0" geometry={nodes['cloud_105_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                  <group name="cloud_106" position={[45.84, 76.9, 238.13]} rotation={[0.63, -0.09, 0.17]}>
                    <mesh name="cloud_106_Material_#0_0" geometry={nodes['cloud_106_Material_#0_0'].geometry} material={materials.Material_0} />
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('./models/rain_3/scene-transformed.glb')
